export const PermissionValues = {
  globalAdmin: '*.*',
  routinespage: {
    read: 'routinespage.read',
  },
  account: {
    all: 'account.*',
    allWorkspace: 'account.*.workspace',
    create: 'account.create',
    invite: 'account.invite',
    update: 'account.update',
    read: 'account.read',
    changeRole: 'account.changeRole',
  },
  activity: {
    all: 'activity.*',
    read: 'activity.read',
  },
  alerts: {
    all: 'workflow.*',
    create: 'workflow.create',
  },
  asset: {
    all: 'asset.*',
    read: 'asset.read',
    create: 'asset.create',
    delete: 'asset.delete',
    update: 'asset.update',
  },
  group: {
    all: 'group.*',
    read: 'group.read',
    create: 'group.create',
  },
  feature: {
    all: 'feature.*',
    create: 'feature.create',
  },
  issue: {
    all: 'issue.*',
  },
  tag: {
    all: 'tag.*',
  },
  tagbatch: {
    all: 'tagbatch.*',
    create: 'tagbatch.create',
  },
  workspace: {
    all: 'workspace.*',
    create: 'workspace.create',
    manageSubscription: 'workspace.manageSubscription',
  },
  product: {
    all: 'product.*',
    read: 'product.read',
    create: 'product.create',
    delete: 'product.delete',
  },
  addon: {
    all: 'addon.*',
    read: 'addon.read',
    create: 'addon.create',
    delete: 'addon.delete',
  },
  filespage: {
    read: 'filespage.read',
  },
  peoplepage: {
    read: 'peoplepage.read',
  },
  grouppage: {
    read: 'grouppage.read',
  },
};

export const GET_ROLES = `
  query FindRoles {
    findRoles(filter: {
      type: { eq: "ACCOUNT" }
    }) {
      items {
        id
        name
      }
    }
  }
`;
